import { FC, useEffect, useState } from 'react';
import { Checkbox } from 'antd';

import { useAntDesignTheme } from '@/hooks/useAntDesignTheme';
import { useEntitlements } from '@/hooks/useEntitlements';
import { PlanTag } from '@/shared';

interface FiscalYearEndProps {
    filters: any;
    handleChange: any;
}

const FiscalYearEnd: FC<FiscalYearEndProps> = ({ filters, handleChange }): JSX.Element => {
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        setLoading(false);
    }, []);

    const { hasMinimumPlan } = useEntitlements();

    const monthsArray = [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'November',
        'December',
    ];

    const { token } = useAntDesignTheme();

    return !hasMinimumPlan('plus') ? (
        <div style={{ textAlign: 'center', margin: '2rem' }}>
            <PlanTag plan={'plus'} style={{ marginLeft: '0.5rem' }} />
        </div>
    ) : (
        <>
            <div style={{ marginBottom: '0.5rem' }}>
                <small style={{ color: token.colorTextTertiary }}>Fiscal Year-End</small>
            </div>
            <Checkbox.Group
                value={filters?.fiscalYearEnd}
                onChange={(checkedValues) => {
                    handleChange(['fiscalYearEnd'], checkedValues);
                }}
            >
                {monthsArray?.map((r: any) => {
                    return (
                        <div key={r} style={{ width: '100%' }}>
                            <Checkbox value={r}>{r}</Checkbox>
                        </div>
                    );
                })}
            </Checkbox.Group>
        </>
    );
};

export default FiscalYearEnd;
